// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__lkfVV","Label":"Checkbox_Label__3wv96","InputElement":"Checkbox_InputElement__XnxJJ","Invalid":"Checkbox_Invalid__3edGV"};